<template>
  <cx-dropdown trigger="click, hover" transition="cv-slidedown" arrow>
    <span v-if="mobile" class="cx-link--stack" :aria-label="$t('aboutMacao.language')">
      <span class="cx-link__icon" aria-hidden="true"><i class="far fa-globe"></i></span>
      <span class="cx-link__text">
        {{currentLocaleName}}
      </span>
    </span>
    <span v-else class="cx-link cx-link--sm" :aria-label="$t('aboutMacao.language')">
      <span class="cx-link__icon" aria-hidden="true">
        <i class="fal fa-globe"></i>
      </span>
      <span>
        {{currentLocaleName}}
      </span>
      <span class="cx-link__icon"><i class="fal fa-angle-down"></i></span>
    </span>
    <template slot="content">
      <ul class="cx-list cx-list--vertical" 
        role="listbox" 
        :aria-activedescendant="`lc-option-${$i18n.locale}`"
        >
        <template v-for="lang in options" >
          <li :key="lang.locale" v-if="!lang.disable"
            class="cx-list__item">
            <a :id="`lc-option-${lang.locale}`" 
              class="cx-link cx-link--xs"
              role="option" 
              :aria-selected="(lang.locale == $i18n.locale) ? 'true' : 'false'"
              :href="`/${lang.locale}/${pureURL}`"
              :class="{
                '-disable': lang.disable, 
                '-active': lang.locale == $i18n.locale
              }"
              @click.prevent="!lang.disable && handleLangChange(lang.locale)">
              {{lang.name}}
              <span class="cx-link__icon"  v-show="lang.locale == $i18n.locale"><i class="fal fa-check"></i></span>
            </a>
          </li>
        </template>
      </ul>
    </template>
  </cx-dropdown>
</template>

<script>
import axios from 'axios';
import Cookies from 'js-cookie';
import supportLocale from '../../server/constants/supportLocale';

export default {
  name: 'language-selector',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    }
  },
  uit() {
    return  [
      ['aboutMacao', ['language']],
    ]
  },
  data() {
    return {
      options: [
        ...supportLocale
      ],
    }
  },
  computed: {
    pureURL: function() {
      let url = this.localedURL(this.$route.fullPath).replace('/', '').split('/');
      url.shift();
      return url.join('/');
    },
    currentLocaleName: function() {
      let localeIdx = this.options.findIndex(({locale}) => {
        return locale == this.$i18n.locale;
      })

      return localeIdx > -1 ? this.options[localeIdx].name : "Languages";
    }
  },
  mounted() {
    this.markPageLangMap200(this.$i18n.locale);
  },
  watch: {
    '$route.path': {
      handler() {
        this.markPageLangMap200(this.$i18n.locale);
      },
      immediate: false,
    },
  },
  methods: {
    handleLangChange(value) {
      let message = this.$i18n.getLocaleMessage(value);
      this.$i18n.setLocaleMessage(value, message);
      this.$i18n.fallbackLocale = this.$i18n.locale;
      this.$i18n.locale = value;
      axios.defaults.params.lang = value;
      document.documentElement.lang = value;
      document.documentElement.dir = this.options.find(({locale}) => locale == value)['dir'] || 'ltr';
      Cookies.set('lang', value, { expires: 90 });
      Cookies.remove('lang', { path: '/', domain: '.macaotourism.gov.mo' });
      this.$router.push('/' + value + '/' + this.$route.fullPath.split('/').slice(2).join('/'));
    },
    markPageLangMap200(lang) {
      if (typeof window === 'undefined') {
        return;
      }
      let pageLangMap = JSON.parse(sessionStorage.getItem('pageLangMap') || '{}');
      if (pageLangMap.path !== this.pureURL) {
        pageLangMap = { path: this.pureURL };
      }
      if (pageLangMap[lang] !== 404) {
        pageLangMap[lang] = 200;
      }
      sessionStorage.setItem('pageLangMap', JSON.stringify(pageLangMap));
    },
  },
}
</script>

<style lang="scss">
  .-disable{
    pointer-events: none;
  }
</style>
